import React, { useRef, useCallback, useEffect } from "react";
import { createButtonPressAnimation } from "../../../../utilities";
import { Sprite } from "@pixi/react";
import * as PIXI from "pixi.js";
import { useDispatch, useSelector } from "react-redux";
import { SOUND_NAME } from "../../../../sounds";
import { ASSET_NAME } from "../../../../assets";
import { soundManager } from "../../../../SoundManager";
import { decrementBet } from "../../../../State/actions";
import {
  selectIsSpinning,
  selectUserInterfaceDisabled,
  selectSessionExpired,
  selectBet,
  selectBets,
  selectAutoPlayActive,
  selectHoldAndWinActive,
} from "../../../../State/selectors";

const BonusButtonDecrementBet = ({ x = 0, y = 0, size }) => {
  const dispatch = useDispatch();

  const isSpinning = useSelector(selectIsSpinning);
  const bet = useSelector(selectBet);
  const bets = useSelector(selectBets);
  const sessionExpired = useSelector(selectSessionExpired);
  const autoPlayActive = useSelector(selectAutoPlayActive);
  const userInterfaceDisabled = useSelector(selectUserInterfaceDisabled);
  const holdAndWinActive = useSelector(selectHoldAndWinActive);

  const buttonSpriteRef = useRef(null);

  // Create brightness filter for hover effect
  const brightnessFilter = useRef(new PIXI.filters.ColorMatrixFilter());
  brightnessFilter.current.brightness(2.0, false);

  const isHoveredRef = useRef(false);

  const texture = PIXI.Assets.get(ASSET_NAME.icon_popi_minus);

  const currentBetIndex = bets.indexOf(bet);

  const canDecreaseBet =
    currentBetIndex > 0 &&
    !isSpinning &&
    !sessionExpired &&
    !autoPlayActive &&
    !userInterfaceDisabled &&
    !holdAndWinActive;

  const handleClick = useCallback(() => {
    if (canDecreaseBet) {
      soundManager.play(SOUND_NAME.button_click);

      if (buttonSpriteRef.current) {
        createButtonPressAnimation(buttonSpriteRef.current);
      }

      dispatch(decrementBet());
    }
  }, [canDecreaseBet, dispatch]);

  const handlePointerOver = useCallback(() => {
    if (canDecreaseBet && buttonSpriteRef.current) {
      isHoveredRef.current = true;
      if (
        !buttonSpriteRef.current.filters ||
        buttonSpriteRef.current.filters.length === 0
      ) {
        buttonSpriteRef.current.filters = [brightnessFilter.current];
      }
    }
  }, [canDecreaseBet]);

  const handlePointerOut = useCallback(() => {
    if (buttonSpriteRef.current) {
      isHoveredRef.current = false;
      buttonSpriteRef.current.filters = [];
    }
  }, []);

  useEffect(() => {
    const sprite = buttonSpriteRef.current;
    return () => {
      if (sprite) {
        sprite.filters = [];
      }
    };
  }, []);

  return (
    <Sprite
      ref={buttonSpriteRef}
      texture={texture}
      name="bonus_button_decrement_bet"
      anchor={0.5}
      width={size}
      height={size}
      x={x}
      y={y}
      hitArea={new PIXI.Circle(0, 0, (size / 2) * 1.4)}
      eventMode={canDecreaseBet ? "static" : "none"}
      cursor={canDecreaseBet ? "pointer" : "default"}
      alpha={canDecreaseBet ? 1 : 0.5}
      onpointertap={handleClick}
      onpointerover={handlePointerOver}
      onpointerout={handlePointerOut}
    />
  );
};

export default BonusButtonDecrementBet;
